export default __webpack_public_path__ + "static/media/graxalta_GxD_jpg_webdesign2021_footerillustrations_03.7c0a2897.jpg";